// @ts-check
import React from 'react';
import styles from './ImageForm.module.scss';
import HForm, { FileInput } from 'shared/containers/portal_layout/HForm';
import LoadingContent from 'shared/components/LoadingContent';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';

export default props => {
  if (!props.currentImage) return <LoadingContent />;
  return (
    <HForm onSubmit={props.handleSubmit}>
      <div className="control-group">
        <label className="control-label">
          <div className={styles.image}>
            <img data-spec-id="profile-image" src={props.currentImage} alt="profile" />
          </div>
        </label>

        <div className="controls">
          <Errors errors={props.error || []} />
          <FileInput placeholder="select a photo to upload" name="image" />
          <div style={{ paddingTop: '15px' }}>
            <SpinnerButton type="submit" className="btn" loading={props.submitting}>
              Save Image
            </SpinnerButton>
          </div>
        </div>
      </div>
      <div className="settings-divider" />
    </HForm>
  );
};
